module.exports = __webpack_public_path__ + "static/media/cites_educatives.b5a4576c.jpg";